<ng-container>
  <!-- STRING FILTER -->
  @if (isStringCache) {
    <div>
      @if (filter.operator !== 'isEmpty' && filter.operator !== 'isNotEmpty') {
        <div>
          <mat-form-field class="filter-chips-field">
            <mat-chip-grid #chipGrid aria-label="Enter keywords" class="filter-chips-grid">
              @for (chip of filter.valueArray; track trackByIndex(chipIdx); let chipIdx = $index) {
                <mat-chip-row
                  (removed)="removeChip.emit({filter, chipIdx})" [editable]="true"
                  (edited)="editChip.emit({filter, chipIdx, $event})" [aria-description]="'press enter to edit ' + chip">
                  {{ chip }}
                  <button matChipRemove [attr.aria-label]="'remove ' + chip">
                    <i class="fa fa-times"></i>
                  </button>
                </mat-chip-row>
              }
              <input [placeholder]="('Add keyword' | translate) + '...'" [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addChip.emit({event: $event, filter})" autocomplete="off" />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        }
      </div>
    }

    <!-- ENUM FILTER -->
    @if (isEnumCache) {
      <div>
        <mat-form-field class="filter-chips-field">
          <mat-select class="filter-select" [(ngModel)]="filter.valueArray" multiple
            (ngModelChange)="filterChange.emit(filter.column.property)">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="filter.search" [noEntriesFoundLabel]="'No options found' | translate"
              [placeholderLabel]="('Search'| translate) + '...'"></ngx-mat-select-search>
            </mat-option>
            @for (option of getFilteredOptions(filter, true); track trackByIndex($index)) {
              <mat-option [value]="option.value">
                {{ option.name | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- OBJECT FILTER -->
    @if (isObjectCache && !isOrgLevelCache) {
      <div>
        <mat-form-field class="filter-chips-field">
          <mat-select class="filter-select" [(ngModel)]="filter.valueArray" multiple
            (ngModelChange)="filterChange.emit(filter.column.property)">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="filter.search" [noEntriesFoundLabel]="'No options found'"
              [placeholderLabel]="('Search'| translate) + '...'"></ngx-mat-select-search>
            </mat-option>
            @for (option of getFilteredOptions(filter); track trackByIndex($index)) {
              <mat-option [value]="option.id">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- HIERARCHICAL ORGANIZATION LEVEL FILTER -->
    @if (isOrgLevelCache) {
      <div>
        <mat-form-field class="filter-chips-field">
          <mat-select class="filter-select" [(ngModel)]="filter.valueArray" multiple
            (ngModelChange)="filterChange.emit(filter.column.property)" panelClass="hierarchical-select-panel">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="filter.search" [noEntriesFoundLabel]="'No options found'"
                [placeholderLabel]="('Search'| translate) + '...'"
              (ngModelChange)="onOrgLevelSearchChange()"></ngx-mat-select-search>
            </mat-option>
            @if (filteredOrgLevels.length === 0) {
              <mat-option disabled>
                {{ 'No options found' | translate }}
              </mat-option>
            }
            <ng-container
            *ngTemplateOutlet="renderOrgTree; context: { nodes: filteredOrgLevels, level: 0 }"></ng-container>
            <ng-template #renderOrgTree let-nodes="nodes" let-level="level">
              @for (node of nodes; track trackById($index, node)) {
                <mat-option [value]="node.id" [ngClass]="'mat-level-' + level">
                  @for (i of [].constructor(level); track trackByIndex(idx); let idx = $index) {
                    <div class="pre-option-line" [ngClass]="'pre-option-level-' + idx"></div>
                  }
                  {{ node.name }}
                </mat-option>
                @if (node.children && node.children.length > 0) {
                  <ng-container
                  *ngTemplateOutlet="renderOrgTree; context: { nodes: node.children, level: level + 1 }"></ng-container>
                }
              }
            </ng-template>
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- BOOL FILTER -->
    @if (isBooleanCache) {
      <div>
        <mat-form-field class="filter-chips-field">
          <mat-select class="filter-select" [(ngModel)]="filter.value"
            (ngModelChange)="filterChange.emit(filter.column.property)">
            <mat-option [value]="true">{{ 'True' | translate }}</mat-option>
            <mat-option [value]="false">{{ 'False' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }

    <!-- DATE FILTER -->
    @if (isDateCache) {
      <div>
        <!-- Single Date Picker -->
        @if (!isRangeCache && !isRelativeTodayCache && filter.operator !== 'isEmpty' && filter.operator !== 'isNotEmpty') {
          <div
            >
            <mat-form-field class="date-field">
              <input class="date-select" matInput [matDatepicker]="picker" [(ngModel)]="filter.value" readonly
                (click)="picker.open()" (dateChange)="filterChange.emit(filter.column.property)" [placeholder]="'Select date' | translate" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          }
          <!-- Date Range Picker -->
          @if (isRangeCache) {
            <div>
              <mat-form-field class="date-field">
                <mat-date-range-input [rangePicker]="rangePicker">
                  <input class="date-start" matStartDate [placeholder]="'Start date' | translate" [(ngModel)]="startDate" readonly
                    (click)="rangePicker.open()" (ngModelChange)="onDateRangeChange()" />
                    <input class="date-end" matEndDate [placeholder]="'End date' | translate" [(ngModel)]="endDate" readonly
                      (click)="rangePicker.open()" (ngModelChange)="onDateRangeChange()" />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #rangePicker></mat-date-range-picker>
                  </mat-form-field>
                </div>
              }
              <!-- Relative to Today -->
              @if (isRelativeTodayCache) {
                <div>
                  <mat-form-field class="date-field" style="width: 100%; display: flex; align-items: center;">
                    <input matInput [value]="(today | date:'yyyy-MM-dd')" disabled placeholder="Today" style="flex: 1;" />
                    <mat-icon class="date-today" aria-disabled="true">calendar_today</mat-icon>
                  </mat-form-field>
                </div>
              }
            </div>
          }

          <!-- NUMBER FILTER -->
          @if (isNumberCache) {
            <div>
              @if (showUnitOptions) {
                <mat-form-field class="filter-chips-field unit-selector">
                  <mat-select [(ngModel)]="filter.selectedUnit" (ngModelChange)="onUnitChange($event)" [placeholder]="'Select unit' | translate">
                    @for (unit of availableUnits; track trackByIndex($index)) {
                      <mat-option [value]="unit.value">
                        {{ unit.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (isRangeCache) {
                <div class="number-filter-container">
                  <mat-form-field class="filter-chips-field">
                    <input class="date-select" matInput placeholder="Min" type="number" [(ngModel)]="min"
                      (ngModelChange)="onNumberRangeChange()" autocomplete="off" />
                      @if (unitAware) {
                        <span matSuffix class="unit-suffix">{{ unitLabel }}</span>
                      }
                    </mat-form-field>
                    <mat-form-field class="filter-chips-field">
                      <input class="date-select" matInput placeholder="Max" type="number" [(ngModel)]="max"
                        (ngModelChange)="onNumberRangeChange()" autocomplete="off" />
                        @if (unitAware) {
                          <span matSuffix class="unit-suffix">{{ unitLabel }}</span>
                        }
                      </mat-form-field>
                    </div>
                  }
                  @if (!isRangeCache) {
                    <div class="number-filter-container">
                      <mat-form-field class="filter-chips-field">
                        <input class="date-select" matInput placeholder="Value" type="number" [(ngModel)]="filter.value"
                          (ngModelChange)="filterChange.emit(filter.column.property)" autocomplete="off" />
                          @if (unitAware) {
                            <span matSuffix class="unit-suffix">{{ unitLabel }}</span>
                          }
                        </mat-form-field>
                      </div>
                    }
                  </div>
                }

              </ng-container>